import clsx from 'clsx';
import { twMerge } from 'tailwind-merge';

import type { ClassValue } from 'clsx';

export default function clsxm<T extends string>(...classes: ClassValue[]): T {
  return twMerge(clsx(...classes)) as T;
}
